// ABOUTME: Step 3 of MFA setup - displays recovery codes with download option.
// ABOUTME: Codes come from the verify-setup response stored in progression data.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ProgressionTab from "../../../../theme/ProgressionBuilder/ProgressionTab";
import Text from "../../../../theme/text/Text";
import Subheading from "../../../../theme/text/Subheading";
import Shbutton from "../../../../theme/buttons/Shbutton";
import { tokens } from "../../../../../theme";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const Content = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const progressionData = useSelector((state) => state.progressiontabs.data);
    const recoveryCodes = progressionData?.recoveryCodes || [];

    const handleDownload = () => {
        const content = [
            "StockHub Recovery Codes",
            "========================",
            "Each code can only be used once.",
            "",
            ...recoveryCodes,
            "",
            `Generated: ${new Date().toISOString()}`,
        ].join("\n");

        const blob = new Blob([content], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "stockhub-recovery-codes.txt";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <Box sx={{ py: 3, px: 2 }}>
            <Box
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[400] : "#fff3e0",
                    border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[500] : "#ffcc80"}`,
                    borderRadius: "8px",
                    p: 2,
                    mb: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                }}
            >
                <WarningAmberOutlinedIcon sx={{ color: "#e65100" }} />
                <Text sx={{ fontSize: "13px", color: theme.palette.mode === "dark" ? colors.txt["primary"] : "#e65100" }}>
                    {t("recovery_codes_warning")}
                </Text>
            </Box>

            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 1,
                    mb: 3,
                }}
            >
                {recoveryCodes.map((code, index) => (
                    <Box
                        key={index}
                        sx={{
                            fontFamily: "monospace",
                            fontSize: "14px",
                            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                            py: 1.5,
                            px: 2,
                            borderRadius: "6px",
                            textAlign: "center",
                            userSelect: "all",
                        }}
                    >
                        {code}
                    </Box>
                ))}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Shbutton
                    variant="outlined"
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    onClick={handleDownload}
                    startIcon={<DownloadOutlinedIcon />}
                >
                    {t("download_as_txt")}
                </Shbutton>
            </Box>
        </Box>
    );
};

const RecoveryCodes = (props) => {
    const { t } = useTranslation();

    return (
        <ProgressionTab
            tabId="tabRecoveryCodes"
            subtitle={t("save_recovery_codes")}
            step={3}
            maxSteps={3}
            singleView={false}
        >
            <Content />
        </ProgressionTab>
    );
};

export default RecoveryCodes;
